<template>
<div class="pdf">
 
  <!-- <iframe scrolling="auto" allowtransparency="true" id="iframe-pdf" name="iframe1"  frameborder="0" :src="'http://ke.yunlearning.com:8081'+this.$store.state.pdfUrl" >
 
  </iframe> -->
<iframe id="iframe-pdf"  :src="'/static/pdf/web/viewer.html?file='+'http://ke.yunlearning.com'+this.$store.state.pdfUrl" frameborder="0"></iframe>
<!-- 'http://image.cache.timepack.cn/nodejs.pdf' -->
</div>
</template>
<script>
import pdf from '../../static/pdf/build/pdf'
export default {
  name: 'Pdf',
 
  data(){
      return {
          childrendata:''
      }
  },
   props:['threepdf'],
 
  mounted(){
 
  },
 
}

</script>

<style>

.pdf{
     width: 9.91rem;
     height: 6.13rem;
     float: left;
      margin-left: 0.03rem;
}
 #iframe-pdf{
     width: 9.91rem;
     height: 6.13rem;
}

 

</style>


// WEBPACK FOOTER //
// src/components/PtSontwo.vue